<div class="content-box">
  <app-breadcrumb [pagina]="conteudo().titulo"></app-breadcrumb>

  <section class="atendimento" aria-labelledby="atendimento-titulo">
    <div class="atendimento-topo">
      <h1 class="atendimento-titulo" id="atendimento-titulo">
        {{ conteudo().titulo }}
        <span class="atendimento-enfeites" aria-hidden="true">
          <span class="atendimento-enfeite-ponto"></span>
          <span class="atendimento-enfeite-traco"></span>
          <span class="atendimento-enfeite-ponto"></span>
        </span>
      </h1>

      @if (conteudo().subtitulo) {
        <p class="atendimento-subtitulo">{{ conteudo().subtitulo }}</p>
      }
    </div>

    <div class="atendimento-divisao" [class.atendimento-divisao-uma-coluna]="imagem().oculta">
      @if (imagem().src; as src) {
        <img
          class="atendimento-ilustracao"
          [ngSrc]="src"
          [width]="imagem().largura"
          [height]="imagem().altura"
          priority
          alt=""
        />
      } @else if (!imagem().oculta) {
        <div class="atendimento-ilustracao-espaco" aria-hidden="true"></div>
      }

      <div class="atendimento-painel">
        <div class="atendimento-busca">
          <label class="atendimento-busca-label" for="atendimento-busca">{{ conteudo().rotuloBusca }}</label>
          <input
            id="atendimento-busca"
            class="atendimento-busca-input"
            type="search"
            autocomplete="off"
            [placeholder]="conteudo().rotuloBusca"
            [disabled]="buscaBloqueada()"
            [value]="termoBusca()"
            (input)="aoBuscar($event)"
          />

          @if (termoBusca()) {
            <button type="button" class="atendimento-busca-limpar" (click)="limparBusca()" aria-label="Limpar busca">
              <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
            </button>
          } @else {
            <i-lucide class="atendimento-busca-icone" name="search" size="18" aria-hidden="true"></i-lucide>
          }
        </div>

        @if (erro()) {
          <div class="atendimento-erro" role="alert">
            <span class="atendimento-erro-icone" aria-hidden="true">
              <i-lucide name="triangle-alert" size="28"></i-lucide>
            </span>

            <p class="atendimento-erro-texto">{{ erro() }}</p>

            <button type="button" class="atendimento-erro-botao" (click)="tentarNovamente()">
              <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
              Tentar novamente
            </button>
          </div>
        } @else if (carregando()) {
          <p class="atendimento-oculto" role="status">Carregando conteúdo.</p>

          <ul class="atendimento-lista" aria-busy="true">
            @for (linha of esqueleto; track linha) {
              <li class="atendimento-esqueleto" aria-hidden="true"></li>
            }
          </ul>
        } @else {
        <ul class="atendimento-lista">
          @for (secao of secoesFiltradas(); track secao.id) {
            <li class="atendimento-item" [class.atendimento-item-aberto]="estaAberta(secao.id)">
              <h2 class="atendimento-item-cabecalho">
                <button
                  type="button"
                  class="atendimento-item-botao"
                  [id]="'secao-botao-' + secao.id"
                  [attr.aria-expanded]="estaAberta(secao.id)"
                  [attr.aria-controls]="'secao-painel-' + secao.id"
                  (click)="alternarSecao(secao.id)"
                >
                  <span class="atendimento-item-icone" aria-hidden="true">
                    <i-lucide [name]="secao.icone" size="20"></i-lucide>
                  </span>

                  <span class="atendimento-item-titulo">{{ secao.titulo }}</span>

                  <i-lucide
                    class="atendimento-item-seta"
                    [name]="estaAberta(secao.id) ? 'chevron-up' : 'chevron-down'"
                    size="18"
                    aria-hidden="true"
                  ></i-lucide>
                </button>
              </h2>

              @if (estaAberta(secao.id)) {
                <div
                  class="atendimento-item-painel"
                  role="region"
                  [id]="'secao-painel-' + secao.id"
                  [attr.aria-labelledby]="'secao-botao-' + secao.id"
                >
                  @if (secao.descricao) {
                    <p class="atendimento-item-descricao">{{ secao.descricao }}</p>
                  }

                  @if (secao.contato; as contato) {
                    <dl class="atendimento-contatos">
                      <div class="atendimento-contato">
                        <dt>{{ contato.rotulo }}</dt>
                        <dd>
                          @if (contato.href) {
                            <a
                              class="atendimento-contato-link"
                              [href]="contato.href"
                              [attr.target]="contato.externo ? '_blank' : null"
                              [attr.rel]="contato.externo ? 'noopener' : null"
                            >
                              {{ contato.valor }}
                            </a>
                          } @else {
                            {{ contato.valor }}
                          }
                        </dd>
                      </div>
                    </dl>
                  }

                  @if (secao.blocos.length) {
                    <ul class="atendimento-blocos">
                      @for (bloco of secao.blocos; track $index) {
                        <li class="atendimento-bloco">
                          @switch (bloco.abertura) {
                            @case ('modal') {
                              <button type="button" class="atendimento-bloco-acao" (click)="abrirModal(bloco)">
                                <i-lucide name="app-window" size="16" aria-hidden="true"></i-lucide>
                                {{ bloco.titulo }}
                              </button>
                            }
                            @case ('pagina') {
                              <a class="atendimento-bloco-acao" [routerLink]="bloco.rota">
                                {{ bloco.titulo }}
                                <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
                              </a>
                            }
                            @case ('nova-aba') {
                              <a class="atendimento-bloco-acao" [routerLink]="bloco.rota" target="_blank" rel="noopener">
                                {{ bloco.titulo }}
                                <i-lucide name="external-link" size="16" aria-hidden="true"></i-lucide>
                                <span class="atendimento-oculto">(abre em nova aba)</span>
                              </a>
                            }
                            @default {
                              <h3 class="atendimento-bloco-titulo">{{ bloco.titulo }}</h3>
                              <div class="atendimento-bloco-texto" [innerHTML]="bloco.html"></div>
                            }
                          }
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
            </li>
          } @empty {
            <li class="atendimento-vazio">
              @if (termoBusca()) {
                Nenhum resultado para "{{ termoBusca() }}".
              } @else {
                Nenhum conteúdo disponível no momento.
              }
            </li>
          }
        </ul>
        }
      </div>
    </div>

    <section class="atendimento-acessos" aria-labelledby="atendimento-acessos-titulo">
      <h2 class="atendimento-oculto" id="atendimento-acessos-titulo">Acesso rápido</h2>

      <ul class="atendimento-acessos-grade">
        <li>
          <a class="atendimento-acesso" data-cor="azul" routerLink="/perguntas-frequentes">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="circle-question-mark" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Perguntas frequentes</span>
          </a>
        </li>

        <li>
          <a class="atendimento-acesso" data-cor="roxo" routerLink="/outros-canais-atendimento">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="headphones" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Outros canais de atendimento ao cidadão</span>
          </a>
        </li>

        <li>
          <a class="atendimento-acesso" data-cor="amarelo" routerLink="/politica-atendimento">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="file-text" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Política de atendimento ao cidadão</span>
          </a>
        </li>

        <li>
          <a class="atendimento-acesso" data-cor="verde" routerLink="/ouvidoria">
            <span class="atendimento-acesso-circulo" aria-hidden="true">
              <i-lucide name="megaphone" size="24"></i-lucide>
            </span>

            <span class="atendimento-acesso-titulo">Ouvidoria geral do município</span>
          </a>
        </li>
      </ul>
    </section>
  </section>

  <dialog
    #modalBloco
    class="atendimento-modal"
    aria-labelledby="atendimento-modal-titulo"
    (close)="aoFecharModal()"
  >
    <div class="atendimento-modal-conteudo">
      <div class="atendimento-modal-topo">
        <h2 class="atendimento-modal-titulo" id="atendimento-modal-titulo">{{ blocoModal()?.titulo }}</h2>

        <button type="button" class="atendimento-modal-fechar" (click)="fecharModal()" aria-label="Fechar">
          <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
        </button>
      </div>

      @if (blocoModal(); as bloco) {
        <div class="atendimento-bloco-texto atendimento-modal-texto" [innerHTML]="bloco.html"></div>
      }
    </div>
  </dialog>
</div>
